require('./myProfileKeysSignatureStep1.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const immutable = require('immutable');
const { changeBiocatchContext } = require("utilities/biocatch");
// @utils
import { recordLinkV2 } from 'utilities/tagging';
// @ components
const SignaturePasscode = require('components/signaturePattern/signaturePatternCodeInput/signaturePasscode/signaturePasscode');
const { SendSignatureKey } = require('components/signaturePattern/sendSignatureKey/sendSignatureKey');
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
// @ constants
const immRequiredDigits = immutable.fromJS([0,1,2,3,4,5,6,7]);
const immDigitsValues = immutable.fromJS([]);
const { SENDING_SIGNATURE_KEY } = require('constants/flagBasedFeatures.js');
const { STEP_1_PROPS } = require('../constants/myProfileKeysSignatureProps');
const biocatch = require("constants/biocatch");
import { 
    MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_EVENT,
    MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_DESCRIPTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_STEP1_ONCHANGE_ACTION_EVENT
} from 'constants/tagging';

class MyProfileKeysSignatureStep1 extends React.Component {      
    constructor(props) {
        super(props);

        this.handleChangeFirstCode = this.handleChangeFirstCode.bind(this);
        this.handleChangeSecondCode = this.handleChangeSecondCode.bind(this);
    }
    componentDidMount() {
        changeBiocatchContext(biocatch.SECURITY_KEYS_PAGE);
    }




    buildError() {
        let content;
        const partialSteps = this.props.immMyProfileKeysSignature.getIn(['partialSteps', 0]);
        const immStep = this.props.immMyProfileKeysSignature.getIn(['steps', 0]);
        // We first check if there are any empty inputs, and only if all inputs are completed we check if the keys are the same
        const validation1 = (partialSteps && partialSteps.get('inputsNull'));
        const validation2 = !immStep.get('firstInput').includes(null) && !immStep.get('secondInput').includes(null);
        const validation3 = !immStep.get('equals');

        if ( validation1 || (validation2 && validation3) ){
            recordLinkV2({
                categoriaEvento: window.utag_data.nombrePagina,
                accionEvento: MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_ACTION_EVENT,
                categoriaError: MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_EVENT,
                descripcionError: MY_PROFILE_KEY_SIGNATURE_STEP1_ERROR_DESCRIPTION_EVENT
            })
            content = (
                <div className="my-profile-keys-signature-step-1__error">{formatText('signatureEdit-errorMatching')}</div>
            );
        }

        return content;
    }

    handleChangeFirstCode(value, position) {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_STEP1_ONCHANGE_ACTION_EVENT,
            etiquetaEvento: position + 1
        })
        this.props.updateFirstField(value, position);
    }

    handleChangeSecondCode(value, position) {
        this.props.updateSecondField(value, position);
    }

    render () {
        const { immFlagBasedFeatures, lowBiocatchAvailable } = this.props;
        const immStep = this.props.immMyProfileKeysSignature.getIn(['steps', 0]);
        const error = this.buildError();
        let sendSignatureKeyContent = null;

        if (immFlagBasedFeatures.get(SENDING_SIGNATURE_KEY) && STEP_1_PROPS[lowBiocatchAvailable].informativeTextWithLink) {
            sendSignatureKeyContent = (
                <div className="my-profile-keys-signature-step-1__send-key">
                    <OKMessage type="informative">
                        <SendSignatureKey />
                    </OKMessage>
                </div>
            )
        }

        return (
            <section className="my-profile-keys-signature-step-1">
                <h2>
                    <FormattedText value={STEP_1_PROPS[lowBiocatchAvailable].stepTitle} />
                </h2>
                <p className={STEP_1_PROPS[lowBiocatchAvailable].stepDescriptionClassName}>
                    <FormattedText value={STEP_1_PROPS[lowBiocatchAvailable].stepDescription} />
                </p>
                {sendSignatureKeyContent}
                <SignaturePasscode
                    immRequiredDigits={immRequiredDigits}
                    immDigitsValues={immDigitsValues}
                    onKeyDown={this.handleChangeFirstCode}
                    onChange={this.handleChangeFirstCode}
                    initialValue={immStep.get("firstInput")}
                    firstInputFocus={true}
                    numbersOnly={true}
                />
                <div className="clearfix" />
                <p>
                    <FormattedText value="signatureEdit-confirmationPasswordSubtitle" />
                </p>
                <SignaturePasscode
                    error={!!error}
                    displayErrorStyles={true}                 
                    immRequiredDigits={immRequiredDigits}
                    immDigitsValues={immDigitsValues}
                    onKeyDown={this.handleChangeSecondCode}
                    onChange={this.handleChangeSecondCode}
                    initialValue={immStep.get("secondInput")}
                    firstInputFocus={false}
                    numbersOnly={true}
                />
                <div className="clearfix" />
                {error}
            </section>
        );
    }
}

MyProfileKeysSignatureStep1.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMyProfileKeysSignature: PropTypes.object.isRequired,
    lowBiocatchAvailable: PropTypes.string.isRequired,
    updateFirstField: PropTypes.func.isRequired,
    updateSecondField: PropTypes.func.isRequired,
};

module.exports = MyProfileKeysSignatureStep1;